import { render, staticRenderFns } from "./ModalSurvey.vue?vue&type=template&id=6e8bd3ff&"
import script from "./ModalSurvey.vue?vue&type=script&lang=js&"
export * from "./ModalSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports